<template>
  <div
    class="image-button"
    :class="{ 'min-box-enter': isEnterBox_ && shake }"
    :title="title"
    @mouseenter="minBoxHover(true)"
    @mouseleave="minBoxHover(false)"
    @click="clickHandle"
  >
    <svg-icon
      :icon-class="isEnterBox_ ? this.enterIcon : this.leaveIcon"
      :style="getIconStyle()"
      style="margin: auto"
    ></svg-icon>
    <slot />
  </div>
</template>

<script>
/**
 * @description 图标按钮
 * @author GuoYun
 */
export default {
  name: 'ImageButton',

  data() {
    return { isEnterBox_: false }
  },
  props: {
    enterIcon: { type: String },
    leaveIcon: { type: String },
    width: {
      type: String,
      default() {
        return '16px'
      },
    },
    height: {
      type: String,
      default() {
        return '16px'
      },
    },
    title: {
      type: String,
      default() {
        return ''
      },
    },
    shake: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  methods: {
    minBoxHover(isEnter) {
      this.isEnterBox_ = isEnter
    },
    clickHandle() {
      this.$emit('click')
    },
    getIconStyle() {
      return 'width:' + this.width + ';height:' + this.height + ';'
    },
  },
}
</script>

<style scoped>
.image-button {
  padding: 5px;
  cursor: pointer;
  display: flex;
  position: relative;
}
.min-box-enter {
  padding: 7px;
}
</style>
